<template>
  <RevDrawer
    :name="MODAL_NAMES.BACK_MARKET_PROMISE"
    :title="i18n(translations.drawerTitle)"
  >
    <template #body>
      <div class="flex flex-col gap-16">
        <RevIllustration
          alt=""
          class="mx-auto"
          :height="189"
          src="/img/checkout/backMarketPromise.png"
          :width="329"
        />
        <h1 class="heading-1">{{ i18n(translations.perksTitle) }}</h1>

        <div>
          <h3 class="heading-3">{{ i18n(translations.perk1title) }}</h3>
          <div class="body-1">{{ i18n(translations.perk1description) }}</div>
        </div>

        <div>
          <h3 class="heading-3">{{ i18n(translations.perk2title) }}</h3>
          <div class="body-1">{{ i18n(translations.perk2description) }}</div>
        </div>

        <div>
          <h3 class="heading-3">{{ i18n(translations.perk3title) }}</h3>
          <div class="body-1">{{ i18n(translations.perk3description) }}</div>
        </div>
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'

import { MODAL_NAMES } from '~/scopes/checkout/config/constants'

import translations from './BackMarketPromiseDrawer.translations'

const i18n = useI18n()
</script>
